import { mapBoxDtoToBoxData } from '../mappers/boxMapper';
import { BoxData } from '../models/Box';
import { BoxDto } from '../models/dtos/BoxDto';
import apiClient from './apiClient';

interface ApiResponse {
  success: boolean;
  status: number;
  data: BoxDto;
}
export const fetchBoxData = async (boxId: string): Promise<BoxData> => {
  const { data: dto } = await apiClient
    .get<ApiResponse>(`/boxes/${boxId}/info`)
    .then((resp) => resp.data);
  return mapBoxDtoToBoxData(dto);
};

export const fetchCurrentDateTime = async (): Promise<string> => {
  const { data: resp } = await apiClient.get<{
    success: boolean;
    status: number;
    data: { current_datetime: string };
  }>('/boxes/current-datetime');
  return resp.data.current_datetime;
};
